module.exports = __webpack_public_path__ + "img/video-white-thumbnail.f6e1fcd4.png";